// CSS
import '../scss/index.scss';

// Polyfills
import './lib/polyfills';

// Vendors
import $ from 'jquery';
import 'fancybox/dist/js/jquery.fancybox.pack';
import 'jquery.maskedinput/src/jquery.maskedinput';
import './lib/wl-share';

// Framework
import capabilities_slider from './framework/capabilities-slider';
import carousels from './framework/carousel';
import code from './framework/code';
import dropdowns from './framework/dropdown';
import expertise_filter from './framework/expertise-filter';
import modals from './framework/modal';
import notices from './framework/notice';
import toggles from './framework/toggle';
import tooltips from './framework/tooltip';
import utilities from './framework/utilities';

// Site modules
import './site/back-to-top';
import './site/mobile-nav';
import './site/search-autosuggest';
import './site/side-nav';
import './site/video-functions';
import './site/video-modals';
import './site/load-more-button';

// TODO: only enqueue these on needed pages
import './site/category-buttons';

// Apply input masks
$('.mask-input-phone').mask('(999) 999-9999');
$('.mask-input-date').mask('99/99/9999');

// Init Fancybox
$('.fancybox').fancybox({
  helpers: {
    overlay: {
      locked: false // Prevent page from jumping back to top
    }
  }
});

// Init single carousel
const carouselSingle = carousels('[data-carousel="single"]', {
  autoplay: true,
  dots: true,
  infinite: true,
  speed: 500
});

// Init content carousel
document.querySelectorAll('[data-carousel="content"]').forEach((carousel) => {
  const autoplay = carousel.getAttribute('data-autoplay') === 'true';
  const dots = carousel.getAttribute('data-dots') === 'true';
  const arrows = carousel.getAttribute('data-arrows') === 'true';

  carousels(carousel, {
    // autoplay: autoplay,
    dots: dots,
    arrows: arrows,
    infinite: false,
    speed: 500,
    prevArrow: arrows
      ? '<button class="custom-prev"><i class="fas fa-arrow-left"></i></button>'
      : null,
    nextArrow: arrows
      ? '<button class="custom-next"><i class="fas fa-arrow-right"></i></button>'
      : null
  });
});

// Init multiple carousel
const carouselMultiple = carousels('[data-carousel="multiple"]', {
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false
});

// Init modals
modals('[data-modal]');

// Init toggles
toggles('[data-toggle-target]');

// Init notices
notices('[data-notice-dismissible]');

// Init code
code('[data-code]');

// Init tooltips
tooltips('[data-tooltip]');

// Init dropdowns
dropdowns('[data-dropdown]');

// Init capabilities slider
capabilities_slider('.capabilities-section');

// Init expertise filter
expertise_filter('.expertise-filter');

document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    const form = event.target;

    const budgetField = form.querySelector('select[name="budget"]');
    const budgetValue = budgetField ? budgetField.value : null;

    const serviceFields = form.querySelectorAll('input[name="services[]"]:checked');
    const services = Array.from(serviceFields)
      .map((el) => el.value)
      .join(', ');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cf7SubmissionSuccess',
      formId: event.detail.contactFormId,
      budget: budgetValue,
      services: services
    });
  },
  false
);

// if #landing_page_form is present, slide the anchor link in from the right after the page has scrolled past the fold
if (document.querySelector('#landing_page_form')) {
  console.log('landing_page_form found');
  const formCTA = document.querySelector('#landing_page_form');
  formCTA.style.right = '-400px'; // initial position off-screen

  // remove u--display-none class after 1 second
  setTimeout(() => {
    formCTA.classList.remove('u--display-none');
  }, 1000);

  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight) {
      formCTA.style.transition = 'right 0.75s ease-in-out';
      formCTA.style.right = '0px'; // slide in
    } else {
      formCTA.style.transition = 'right 0.75s ease-in-out';
      formCTA.style.right = '-400px'; // slide out
    }
  });
}

// Scroll to form if success message is visible
document.addEventListener('DOMContentLoaded', scollToForm);
function scollToForm() {
  const successMessage = document.getElementById('contact-form-success');
  if (
    successMessage &&
    !successMessage.classList.contains('u--display-none') &&
    !successMessage.classList.contains('scrolled-to')
  ) {
    const formElement = document.querySelector('.wpcf7');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });

      // Add class to flag that we've scrolled to prevent repeated scrolling
      successMessage.classList.add('scrolled-to');
    }
  }
}
